import { render } from "./MainAccountsPayable.vue?vue&type=template&id=4279cb7c&scoped=true"
import script from "./MainAccountsPayable.vue?vue&type=script&lang=js"
export * from "./MainAccountsPayable.vue?vue&type=script&lang=js"

import "./MainAccountsPayable.vue?vue&type=style&index=0&id=4279cb7c&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4279cb7c"]])

export default __exports__